export const CLUB_VISIBILITIES = {
    HIDDEN: 0,
    VISIBLE: 1,
};
